import { Autocomplete, Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { TTransactionsFilters } from "../../Models/Transactions"
import useService from "../../hooks/useService";
import { searchCustomers as searchCustomersService } from "../../services/Customer";
import { searchPvcCenters } from "../../services/Transactions";
import { CalendarIcon, LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { MomentInput } from "moment";
import { REDEEM_AT_PVC_TRANSACTION_STATUS, TRANSACTION_STATUS, TRANSACTION_TYPES } from "../../utils/constant";
import { TOption } from "../../Models/common";



export const initialTransactionFilters: TTransactionsFilters = {
    customer: '',
    fromDate: '',
    location: '',
    secondaryLocation: '',
    toDate: '',
    transactionType: '',
    globalTransactionNumber: '',
    status: ''
}

const FiltersForm = (props:{setFilters:(params:TTransactionsFilters) => any}) => {
    const { setFilters } = props
    const [formData, setFormData] = useState<TTransactionsFilters>(initialTransactionFilters)
    const { execute, store } = useService()
    const { pvcCenters } = store.transactionsStore
    const [customersOptions, setCustomersOptions] = useState<TOption[]>([])
    const [locationOptions, setLocationOptions] = useState<TOption[]>([])
    const [timer, setTimer] = useState<NodeJS.Timeout>()

    const changeHandler = (value: string, id: keyof TTransactionsFilters) => {
        setFormData(prev => ({ ...prev, [id]: value }))
    }

    const searchCustomer = (searchString: string) => {
        if (timer) clearTimeout(timer)
        if (searchString.length < 2) return
        const timeout = setTimeout(() => {
            execute(() => searchCustomersService({ searchString }))
                .then(({ data }) => {
                    console.log('search customers response', data)
                    if (data !== null) setCustomersOptions(data.map(customer => ({ label: customer.fullName, value: customer.customerRefNo })))
                })
        }, 500)
        setTimer(timeout)
    }

    // const searchLocation = (searchString: string, secondary = false) => {
    //     if (timer) clearTimeout(timer)
    //     if (searchString.length < 2) return
    //     const timeout = setTimeout(() => {
    //         execute(() => searchPvcCenters({ searchString }))
    //             .then(({ data }) => {
    //                 if (data !== null && secondary) setSecondaryLocationOptions(data.map(location => ({ label: location.name, value: location.id! })))
    //                 else if (data !== null) setLocationOptions(data.map(location => ({ label: location.name, value: location.id! })))
    //             })
    //     }, 500)
    //     setTimer(timeout)
    // }

    const submitHanler = (e:any) => {
        console.log('submit', formData)
        e.preventDefault()
        setFilters(formData)
    }

    const resetFilters = () => {
        setFilters(initialTransactionFilters)
        setFormData(initialTransactionFilters)
    }

    useEffect(() => {
        setLocationOptions(pvcCenters.map(location => ({ label: location.name, value: location.id! })))
    }, [pvcCenters])

    return <form style={{ display: 'flex', gap: '10px', flexDirection: 'column' }} onSubmit={submitHanler}>
        <div style={{ display: 'flex', gap: '10px' }}>
            <div style={{ flex: 1 }}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDatePicker
                        slotProps={{
                            textField: { fullWidth: true, size: 'small' },
                            field: {
                                InputProps: {
                                    endAdornment: <IconButton><CalendarIcon /></IconButton>
                                }
                            }
                        }}
                        label='Date From'
                        onChange={(value) => changeHandler(value?.toString()!, 'fromDate')}
                        value={formData.fromDate ? moment(formData.fromDate) : null}
                    />
                </LocalizationProvider>
            </div>
            <div style={{ flex: 1 }}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDatePicker
                        slotProps={{
                            textField: { fullWidth: true, size: 'small' },
                            field: {
                                InputProps: {
                                    endAdornment: <IconButton><CalendarIcon /></IconButton>
                                }
                            }
                        }}
                        label='Date To'
                        onChange={(value) => changeHandler(value?.toString()!, 'toDate')}
                        value={formData.toDate ? moment(formData.toDate) : null}
                    />
                </LocalizationProvider>
            </div>
            <div style={{ flex: 1 }}>
            <FormControl fullWidth size='small'>
                    <InputLabel id={`transaction_status_label`}>Transaction Status</InputLabel>
                    <Select
                        onChange={(e) => changeHandler(e.target.value, 'status')}
                        labelId='transaction_status_label'
                        id='transaction_status'
                        label='Transaction Status'
                        value={formData.status}
                    >
                        {Object.keys(REDEEM_AT_PVC_TRANSACTION_STATUS).map(elem => {
                            return (
                                <MenuItem value={elem}>{elem.replaceAll('_', ' ')}</MenuItem>
                            )
                        })}
                    </Select>
                </FormControl>
            </div>
            <div style={{ flex: 1 }}>
                <Autocomplete
                    size='small'
                    fullWidth
                    options={customersOptions}
                    value={formData.customer ? customersOptions?.filter(option => option.value === formData['customer'])[0] : null}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, newValue) => changeHandler(newValue?.value!, 'customer')}
                    renderInput={(params) => <TextField
                        label="Customer"
                        onChange={(e) => searchCustomer(e.target.value)}
                        {...params}
                        placeholder="Enter Customer Name"
                    />}
                    
                />
            </div>
            <div style={{ flex: 1 }}>
                <TextField
                    label='Order ID'
                    size='small'
                    fullWidth
                    value={formData.globalTransactionNumber || null}
                    onChange={(event) => changeHandler(event.target.value!, 'globalTransactionNumber')}
                />
            </div>
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <Button type='button' onClick={resetFilters}>Clear Filters</Button>
            <Button type="submit" variant="contained">Apply Filters</Button>
        </div>
    </form>
}

export default FiltersForm